import { Button } from '@daily/shared/components/Button';
import { Modal } from '@daily/shared/components/Modal';
import { Text } from '@daily/shared/components/Text';
import { useDevices } from '@daily-co/daily-react';
import { useTranslation } from 'react-i18next';

interface Props extends React.ComponentProps<typeof Modal> {}

export const DeviceInUseModal: React.FC<React.PropsWithChildren<Props>> = (
  props
) => {
  const { t } = useTranslation();
  const { camState } = useDevices();

  const camInUse = camState === 'in-use';

  return (
    <Modal
      actions={[
        <Button id="device-in-use-modal-close" key="close" variant="primary">
          {props.closeText}
        </Button>,
      ]}
      title={
        camInUse
          ? t('haircheck.deviceInUse.title_camera')
          : t('haircheck.deviceInUse.title_other')
      }
      {...props}
    >
      <Text El="p" variant="large">
        {camInUse
          ? t('haircheck.deviceInUse.desc_camera')
          : t('haircheck.deviceInUse.desc_other')}
      </Text>
    </Modal>
  );
};
